



















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { withRank } from "@/req/home";
import qs from "@/components/queSheng.vue";
@Component({
  components: {
    qs,
  },
})
export default class Logout extends Vue {
  public type: any = 4;
  public page: any = 1;
  public tagId = "";
  public versionId = "";
  public data: any = [];
  public active: any = 4;
  public listView = [
    {
      name: "推荐榜",
      type: 4,
    },
    {
      name: "新服榜",
      type: 1,
    },
    {
      name: "人气榜",
      type: 2,
    },
  ];
  public nums = 0;
  public mounted() {
    window.addEventListener("scroll", this.add);
    if (this.$route.path == "/home/list") {
      if (this.$route.query.id != undefined) {
        this.active = this.$route.query.id;
        this.type = this.$route.query.id;
        this.getwithRank();
      } else {
        this.getwithRank();
      }
      return false;
    }
  }
  public destroyed() {
    window.removeEventListener("scroll", this.add);
  }
  public add() {
    const a = document.documentElement.scrollTop;
    const b = document.documentElement.clientHeight;
    const c = document.documentElement.scrollHeight;
    if (c - a - b < 1) {
      if (this.nums > this.data.length) {
        this.page = this.page + 1;
        this.getwithRank();
      }
    }
  }
  public async getwithRank() {
    const obj = {
      token: this.$fn.cookies.getToken(),
      versionid: this.versionId == null ? "" : this.versionId,
      tag: this.tagId == null ? "" : this.tagId,
      type: this.type,
      page: this.page,
      size: 50,
    };
    const res = await withRank(obj);
    if (res.code == 200) {
      this.nums = res.data.game_info.total;
      const newArr = [...this.data, ...res.data.game_info.data];
      this.data = newArr;
    }
  }
  @Watch("$store.state.withRank.versions")
  public change() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.versionId = this.$store.state.withRank.versions;
    this.data = [];
    this.page = 1;
    this.nums = 0;
    this.getwithRank();
  }
  @Watch("$store.state.withRank.tag")
  public changes() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.tagId = this.$store.state.withRank.tag;
    this.data = [];
    this.page = 1;
    this.nums = 0;
    this.getwithRank();
  }
  @Watch("$route")
  public routeChange() {
    if (this.$route.path == "/list") {
      if (this.$route.query.id != undefined) {
        this.data = [];
        this.active = this.$route.query.id;
        this.type = this.$route.query.id;
        this.getwithRank();
      }
    }
  }
  // tab点击切换
  public handle(item) {
    this.data = [];
    this.page = 1;
    this.nums = 0;
    this.active = item.type;
    this.type = this.active;
    this.getwithRank();
  }
  public toTags(list) {
    if (list == "") {
      return [];
    }
    const arr = list.split("|");
    return arr;
  }
  public toNum(num) {
    return num;
    // return Number(num).toFixed(1);
  }
}
